import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    paddingHorizontal: theme.spacing[6],
  },
  containerSelected: {
    paddingHorizontal: theme.spacing[6],
    borderColor: colors.borderSelected,
    backgroundColor: colors.backgroundBrand,
    _web: {
      _active: {
        backgroundColor: colors.backgroundBrand,
      },
      _hover: {
        backgroundColor: colors.backgroundBrandHover,
      },
    },
  },
}));
